import AddUserModal from  './AddUserModal'

export default AddUserModal



// WEBPACK FOOTER //
// ./src/components/AddUserModal/index.js